<div class="lprGroupsHeader">
  <sn-icon-button [matTooltip]="'common.refresh' | t" (click)="reload()">
    <sn-icon fontSet="fal" fontIcon="fa-redo-alt"></sn-icon>
  </sn-icon-button>
</div>
<ng-container *ngIf="isLoading">
  <mat-progress-spinner
    class="progress-spinner"
    color="accent"
    diameter="32"
    mode="indeterminate"
  ></mat-progress-spinner>
</ng-container>
<mat-table [dataSource]="dataSource" matSort matSortDisableClear>
  <ng-container matColumnDef="name">
    <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'common.group' | t }}</mat-header-cell>
    <mat-cell *matCellDef="let item" class="groupNames">
      <p *ngIf="item.name">{{ item.name }}</p>
      <p *ngIf="!item.name">{{ 'map.lprComponents.ungrouped' | t }}</p>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="num_plates">
    <mat-header-cell *matHeaderCellDef>{{ 'map.lprComponents.numPlates' | t }}</mat-header-cell>
    <mat-cell *matCellDef="let item">
      {{ item.count }}
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="actions">
    <mat-header-cell *matHeaderCellDef>{{ 'common.actions' | t }}</mat-header-cell>
    <mat-cell *matCellDef="let item">
      <sn-icon-button *ngIf="canCreate" (click)="viewPlates(item)" [matTooltip]="'map.lprComponents.managePlates' | t">
        <sn-icon fontSet="fal" fontIcon="fa-object-group"></sn-icon>
      </sn-icon-button>
      <sn-icon-button
        *ngIf="item.id && canDelete"
        (click)="removeGroup(item, lprHotlist.id)"
        color="danger"
        [matTooltip]="'map.lprComponents.deleteGroup' | t"
      >
        <sn-icon fontSet="fal" fontIcon="fa-trash-alt"></sn-icon>
      </sn-icon-button>
    </mat-cell>
  </ng-container>

  <mat-header-row *matHeaderRowDef="columns"></mat-header-row>
  <mat-row *matRowDef="let item; columns: columns"> </mat-row>
</mat-table>

<div class="lprGroupsFooter">
  <button mat-button color="danger" mat-dialog-close>{{ 'common.close' | t }}</button>
  <button mat-button color="success" (click)="addGroup()"><sn-icon>add</sn-icon> {{ 'common.addGroup' | t }}</button>
  <mat-paginator #paginator [pageSize]="pageSize" [length]="resultsLength"></mat-paginator>
</div>
